export default (http) => {
    return {
        queryByPage (data){
            return http.json({
                url: '/evaluate/pageByEvaluateVO',
                data
            })
        },

        list (data){
            return http.json({
                url: '/evaluate/list',
                data
            })
        },
        /**
         * 保存信息
         * @param data
         * @returns {*}
         */
        save(data) {
            return http.json({
                url: '/evaluate/save',
                data
            })
        },
        /**
         * 获取详情
         * @param data
         * @return {*}
         */
        getInfo(data) {
            return http.json({
                url: `/evaluate/get?id=${data.id}`
            })
        },
        /**
         * 删除
         * @param data
         * @returns {*}
         */
        remove(data) {
            return http.json({
                url: `/evaluate/delete?id=${data[0].id}`,
                data
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/evaluate.js